import { Button } from '@chakra-ui/react';
import { ReactComponent as NewTabIcon } from 'assets/icons/new-tab.svg';
import { BRAND_REDIRECT_LINK } from 'constants/links';
import { useTranslation } from 'react-i18next';

interface SimpleBrandKitButtonProps {
  hasEditPermission: boolean;
  ariaLabel?: string;
}
export const SimpleBrandKitButton = ({ hasEditPermission, ariaLabel }: SimpleBrandKitButtonProps) => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.brandKit' });
  if (!hasEditPermission) {
    return null;
  }

  return (
    <Button
      as='a'
      href={BRAND_REDIRECT_LINK}
      target='_blank'
      rel='noopener noreferrer'
      leftIcon={<NewTabIcon />}
      size='sm'
      variant='ghost'
      aria-label={ariaLabel}
    >
      {t('edit')}
    </Button>
  );
};
